const _version = "2.5.4"
function version() {
    return _version;
}
export default version
